import React from 'react';
import './PersonalLoanPrequalFunnel.scss';
import Label from 'components/form/Label/Label';
import { Row } from 'components/Containers/Row/Row';
import SectionContainer from 'components/Containers/SectionContainer';
import { Button } from 'components/form/Button/Button';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useEventHandler } from 'hook/event.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import classnames from 'classnames';
import { Slider } from 'components/Slider/Slider';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as IconRocket } from 'style_icons/art-rocket.svg';
import { ReactComponent as IconClock } from 'style_icons/art-clock.svg';
import { ReactComponent as IconBank } from 'style_icons/art-bank-2.svg';
import { ReactComponent as IconPayment } from 'style_icons/art-payment.svg';
import { ReactComponent as IconCash } from 'style_icons/art-cash.svg';
import { ReactComponent as IconShopping } from 'style_icons/art-shopping.svg';
import { commafy } from 'helpers/number';
import { PERSONAL_LOAN_PREQUAL } from 'types/morph.pagePosition.constants';
import { PERSONAL_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';
import { Link } from 'components/navigation/Link/Link';
import { redirectPersonalLoanOfferWithStaticModule } from 'actions/offers.actions';
import { useDispatch } from 'react-redux';

const GetVariationView = ({
  onClickPrequal,
  onClickLoanAmount,
  handleNonPrequalLinkClick,
  prequalLoanAmount,
  setPrequalLoanAmount,
  personalLoanPrequalFunnelFlagConfig,
}) => {
  return (
    <div className="personalLoanTopModuleVar1">
      <SectionContainer className="sectionContainer padB40 m-padB20 margB32">
        <Row>
          <div className="content-wrapper flex-container justify-between m-flex-column">
            <FlexContainer className="m-margB10 flex-column m-flex-row image-section">
              <Label
                className="H3 margB24 m-margB0 text-center m-margL24 m-text-left"
                for="slider"
                typeHeader="h3"
              >
                {personalLoanPrequalFunnelFlagConfig.prequal_funnel_subtitle}
              </Label>
              <img alt="art prequal" className="plPrequalImage" />
            </FlexContainer>
            <div>
              <Label
                className="text-24 m-text-20 margB8 text-weight-800"
                typeHeader="h3"
              >
                How much do you need?
              </Label>
              <div className="margB24 m-text-12 fontGray400">
                (Between $2,000 to $50,000)
              </div>
              <div className="bold primary_text_light margLRAuto text-28 text-center">
                ${commafy(prequalLoanAmount)}
              </div>
              <Slider
                min={2000}
                max={50000}
                step={500}
                value={prequalLoanAmount}
                className="prequalSlider"
                size="big"
                onChange={setPrequalLoanAmount}
                onAfterChange={onClickLoanAmount}
              />
              <Button
                mrphType="primary"
                onClick={() => onClickPrequal(prequalLoanAmount)}
                fullWidth={true}
                className="margT40 border-rad100px"
              >
                {personalLoanPrequalFunnelFlagConfig.prequal_funnel_cta_label}
              </Button>
            </div>
          </div>
        </Row>
      </SectionContainer>
      <FlexContainer className="justify-between pl-prequal-value-props flex-mobile-col">
        <SectionContainer>
          <Row>
            <Label className="text-24 bold margB24" typeHeader="h3">
              {personalLoanPrequalFunnelFlagConfig.prequalify_section_title}
            </Label>
            <FlexContainer className="justify-content margB16 items-align-center">
              <div>
                <IconClock />
              </div>
              <div className="text-14 margL32 lineHeight-1-33">
                {
                  personalLoanPrequalFunnelFlagConfig.prequalify_section_bullet_1
                }
              </div>
            </FlexContainer>
            <FlexContainer className="justify-content  margB16 items-align-center">
              <div>
                <IconBank />
              </div>
              <div className="text-14 margL32 lineHeight-1-33">
                {
                  personalLoanPrequalFunnelFlagConfig.prequalify_section_bullet_2
                }
              </div>
            </FlexContainer>
            <FlexContainer className="justify-content items-align-center">
              <div>
                <IconRocket />
              </div>
              <div className="text-14 margL32 lineHeight-1-33">
                {
                  personalLoanPrequalFunnelFlagConfig.prequalify_section_bullet_3
                }
              </div>
            </FlexContainer>
          </Row>
        </SectionContainer>
        <SectionContainer>
          <Row>
            <Label className="text-24 bold margB24" typeHeader="h3">
              {personalLoanPrequalFunnelFlagConfig.personal_loan_section_title}
            </Label>
            <FlexContainer className="justify-content margB16 items-align-center">
              <div>
                <IconCash />
              </div>
              <div className="text-14 margL32 lineHeight-1-33">
                {
                  personalLoanPrequalFunnelFlagConfig.personal_loan_section_bullet_1
                }
              </div>
            </FlexContainer>
            <FlexContainer className="justify-content  margB16 items-align-center">
              <div>
                <IconShopping />
              </div>
              <div className="text-14 margL32 lineHeight-1-33">
                {
                  personalLoanPrequalFunnelFlagConfig.personal_loan_section_bullet_2
                }
              </div>
            </FlexContainer>
            <FlexContainer className="justify-content items-align-center">
              <div>
                <IconPayment />
              </div>
              <div className="text-14 margL32 lineHeight-1-33">
                {
                  personalLoanPrequalFunnelFlagConfig.personal_loan_section_bullet_3
                }
              </div>
            </FlexContainer>
          </Row>
        </SectionContainer>
      </FlexContainer>

      <FlexContainer className="justify-center items-align-center">
        <Link
          className="text-center secondary_text_light Body-2 bold margB48 pointer"
          onClickCallback={handleNonPrequalLinkClick}
          ariaLabel={'Search without pre-qualification'}
        >
          Search without pre-qualification
        </Link>
      </FlexContainer>

      <div className="fontGray400 caption m-padLR16">
        *Application processing and approval times are determined by our
        partners. Please read the full offer terms and conditions to learn more.
      </div>
    </div>
  );
};

export const PersonalLoanPrequalFunnel = ({
  showPrequalTopModule,
  isOverview,
  isActionsModule,
  ...props
}) => {
  const eventHandler = useEventHandler();
  const dispatch = useDispatch();
  const title = isOverview
    ? 'See if you’re pre-qualified for personal loans'
    : 'See if you’re pre-qualified';
  const sectionClass = classnames('sectionContainer padB40 m-padB20', {
    margB32: !isOverview && !isActionsModule,
  });

  const viewModuleProps = getViewModuleTrackingAttributes({
    pagePosition: PERSONAL_LOAN_PREQUAL,
    modulePosition: 1,
    vertical: 'Personal Loan',
    pageName: 'Offers - Personal Loans',
  });
  useViewModule(viewModuleProps, !isOverview && !isActionsModule);

  const seenPixel = useSeenModulePixel(
    viewModuleProps,
    !isOverview && !isActionsModule,
  );

  function onClickPrequal(loanAmount) {
    eventHandler(CLICK, {
      'Click Type': 'Check Pre-Qualification',
      Vertical: PERSONAL_LOAN_VERTICAL,
      'Module Position': props.modulePosition,
      'Module Name': PERSONAL_LOAN_PREQUAL,
    });

    dispatch(
      redirectPersonalLoanOfferWithStaticModule(
        props.history,
        'PREQUAL_FUNNEL',
        `loanAmount=${loanAmount}`,
      ),
    );
  }

  function onClickLoanAmount() {
    eventHandler(CLICK, {
      'Click Type': 'Personal Loan Prequal Amount Slider',
      Vertical: PERSONAL_LOAN_VERTICAL,
      'Module Name': PERSONAL_LOAN_PREQUAL,
    });
  }

  if (!showPrequalTopModule) {
    return '';
  }

  if (!isOverview && !isActionsModule) {
    if (props.showOffers) {
      return '';
    } else {
      return (
        <>
          {seenPixel}
          <GetVariationView
            onClickPrequal={onClickPrequal}
            onClickLoanAmount={onClickLoanAmount}
            prequalLoanAmount={props.prequalLoanAmount}
            setPrequalLoanAmount={props.setPrequalLoanAmount}
            handleNonPrequalLinkClick={props.handleNonPrequalLinkClick}
            personalLoanPrequalFunnelFlagConfig={
              props.personalLoanPrequalFunnelFlagConfig
            }
          />
        </>
      );
    }
  } else {
    return (
      <>
        {seenPixel}
        <div className="personalLoanTopModule">
          <SectionContainer className={sectionClass}>
            <Row>
              <div className="flex-container justify-between m-flex-column">
                <div className="FlexContainer flex-column">
                  <Label typeHeader={'h3'} className="H3 margB16">
                    {title}
                  </Label>
                  <Label typeHeader={'h4'} className="h4 margB8 mobile-Body-1">
                    You may get up to $50,000
                  </Label>
                  <ul className="bulletPoints Body-1 margB24 mBody-2">
                    <li>Get funds in as little as one day</li>
                    <li>Get rates as low as 3.49%</li>
                  </ul>
                  <div className="mobileHide">
                    <Button mrphType="primary" onClick={() => onClickPrequal()}>
                      Check Pre-Qualification
                    </Button>
                  </div>
                </div>
                <div className="m-margB24 ">
                  <img alt="art prequal" className="plPrequalImage" />
                </div>
                <div className="desktopHide">
                  <div className="mBody-2 text-center margB8">
                    Checking your rate won’t hurt your credit
                  </div>
                  <Button mrphType="primary" onClick={() => onClickPrequal()}>
                    Check Pre-Qualification
                  </Button>
                </div>
              </div>
            </Row>
          </SectionContainer>
          {!isOverview && !isActionsModule && (
            <Row fullWidth>
              <Label type="H2 margB16 mH5">Search our loan offers</Label>
            </Row>
          )}
        </div>
      </>
    );
  }
};
